const BOLTS = 8;
const NUMS = Array.from({ length: 10 }, (_, i) => i);

export function VaultDoor({ size = 160, angle = 0, lit = 0, open = false, spinning = false }) {
  return (
    <div className="relative mx-auto" style={{ width: size, height: size, perspective: 900 }} data-testid="vault-door">
      <div className="absolute inset-[6%] rounded-full bg-[radial-gradient(circle,#FDE68A_0%,#F59E0B_45%,#78350F_100%)] vault-treasure-glow" />
      <div className={`absolute inset-0 vault-door-leaf ${open ? "vault-door-open" : ""}`} data-open={open}>
        <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[0_10px_25px_rgba(0,0,0,0.6)]">
          <defs>
            <radialGradient id="vd-steel" cx="38%" cy="32%" r="75%"><stop offset="0" stopColor="#64748B" /><stop offset="0.55" stopColor="#334155" /><stop offset="1" stopColor="#0F172A" /></radialGradient>
            <linearGradient id="vd-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#FDE68A" /><stop offset="0.5" stopColor="#F59E0B" /><stop offset="1" stopColor="#B45309" /></linearGradient>
          </defs>
          <circle cx="100" cy="100" r="97" fill="url(#vd-gold)" />
          <circle cx="100" cy="100" r="89" fill="url(#vd-steel)" />
          {Array.from({ length: BOLTS }).map((_, i) => {
            const r = (i / BOLTS) * Math.PI * 2 - Math.PI / 2;
            const on = i < lit * 2;
            return <circle key={i} cx={100 + Math.cos(r) * 78} cy={100 + Math.sin(r) * 78} r="6" className="transition-[fill] duration-300" fill={on ? "#FBBF24" : "#1E293B"} stroke={on ? "#FEF3C7" : "#475569"} strokeWidth="1.5" style={on ? { filter: "drop-shadow(0 0 6px #FBBF24)" } : undefined} />;
          })}
          <g style={{ transform: `rotate(${angle}deg)`, transformOrigin: "100px 100px", transition: spinning ? "transform 950ms cubic-bezier(.2,.75,.25,1)" : "transform 300ms ease-out" }}>
            <circle cx="100" cy="100" r="58" fill="#0B1220" stroke="url(#vd-gold)" strokeWidth="3" />
            {NUMS.map((n) => {
              const r = (n / 10) * Math.PI * 2 - Math.PI / 2;
              return (
                <g key={n}>
                  <line x1={100 + Math.cos(r) * 52} y1={100 + Math.sin(r) * 52} x2={100 + Math.cos(r) * 45} y2={100 + Math.sin(r) * 45} stroke="#F59E0B" strokeWidth="2" />
                  <text x={100 + Math.cos(r) * 36} y={100 + Math.sin(r) * 36 + 4} textAnchor="middle" fontSize="11" fontWeight="800" fill="#FDE68A">{n}</text>
                </g>
              );
            })}
            {[0, 120, 240].map((a) => <rect key={a} x="96" y="70" width="8" height="30" rx="4" fill="url(#vd-gold)" transform={`rotate(${a} 100 100)`} />)}
            <circle cx="100" cy="100" r="11" fill="url(#vd-gold)" stroke="#78350F" strokeWidth="2" />
          </g>
          <path d="M100 6 l-6 -2 h12 z" fill="#F43F5E" />
        </svg>
      </div>
    </div>
  );
}
